import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

interface TabItem {
  label: string;
  route: string;
  active?: boolean;
}

@Component({
  selector: 'app-tab-header',
  templateUrl: './tab-header.component.html',
  styleUrls: ['./tab-header.component.scss']
})
export class TabHeaderComponent {
  @Input() tabs: TabItem[] = [];

  constructor(private router: Router) {}

  isActiveRoute(route: string): boolean {
    return this.router.url.includes(route);
  }

  navigateTo(route: string): void {
    this.router.navigate([route]).catch((err) => {
      console.log('Navigation error:', err);
    });
  }
}
